import "./App.scss";
// import Header from "@/components/Header";
import Data from "@/components/Data";
import Five from "@/components/Five";
// import Scene from "./components/Scene";
import Footer from "./components/Footer";
import BackTop from "@/assets/back-top.png";
import Feedback from "./components/Feedback";
import contactus from "@/assets/contact_us.png";
import { useState } from "react";
import Header from "@/com/Header"
import Product from "@/com/Product"
import Competitiveness from "@/com/Competitiveness"
import CoreProducts from "@/com/CoreProducts"
import Scene from "@/com/Scene"
// import UserProtocol from "./components/UserProtocol"
// import PravicyProtocol from "./components/PravicyProtocol"
function App() {
  // 返回顶部按钮
  function backToTop() {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  }
  const [navBgc, setNavBgc] = useState("transparent")
  const [shadow, setShadow] = useState("")
  window.addEventListener("scroll", function (e) {
    if (document.documentElement.scrollTop >= 750) {
      setNavBgc("#fff")
      setShadow("0px 5px 12.8px 0px rgba(0, 0, 0, 0.08)")
    } else {
      setNavBgc("transparent")
      setShadow("")
    }
    var button = document.getElementById("scrollToTopButton");
    if (button) {
      var currentScroll =
        document.documentElement.scrollTop || document.body.scrollTop;
      if (currentScroll > 100) {
        button.style.display = "block";
      } else {
        button.style.display = "none";
      }
    }
  });
  // 联系我们浮窗
  const [isHide, setIshide] = useState(true);
  const [position, setPosition] = useState({ top: "-90px", left: "-245px" });
  function contactusEnter() {
    setIshide(false);
  }
  function contactusLeave() {
    setIshide(true);
  }
  return (
    <div className="App">
      <Header navBgc={navBgc} shadow={shadow} />
      <Product />
      <Competitiveness />
      <CoreProducts />
      <Scene />
      {/* <About /> */}
      {/* <Data /> */}
      {/* <Five /> */}
      {/* <Scene /> */}
      <Footer />
      {/* <UserProtocol/> */}
      {/* <PravicyProtocol/> */}
      {/* 返回顶部按钮 */}
      <div id="scrollToTopButton" className="back-to-top" onClick={backToTop}>
        <img src={BackTop} className="img" />
      </div>
      {/* 联系我们浮窗 */}
      <div
        id="contactusDom"
        className="contact-us"
        onMouseEnter={contactusEnter}
        onMouseLeave={contactusLeave}
      >
        <img src={contactus} className="img"></img>
        {/* 返回表二维码 */}
        <Feedback
          isHide={isHide}
          position={position}
          tip="扫码联系再查查客服"
        />
      </div>
    </div>
  );
}

export default App;
